import { createCatalog, deleteCatalog, getCatalog, updateCatalog } from "../../api/catalog.js";
import { toArray, toObject } from "../../utils/languageContent";

const catalog = {
    namespaced: true,
    state: {
        catalogs: [],
    },
    mutations: {
        SET_CATALOG: (state, payload) => {
            state.catalogs = payload;
        },
        ADD_CATALOG: (state, payload) => {
            state.catalogs.push(payload);
        },
        UPDATE_CATALOG: (state, payload) => {
            state.catalogs = state.catalogs.map((p) => {
                if (p._id === payload._id) {
                    return payload;
                }
                return p;
            });
        },
        DELETE_CATALOG: (state, id) => {
            state.catalogs = state.catalogs.filter((r) => r._id !== id);
        },
    },
    actions: {
        getCatalogs({ commit }, id = null) {
            return getCatalog(id).then((response) => {
                commit(
                    "SET_CATALOG",
                    response.data.map((x) => toObject(x))
                );
            });
        },
        createCatalog({ commit }, payload) {
            return createCatalog(toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("ADD_CATALOG", data);
            });
        },
        updateCatalog({ commit }, payload) {
            return updateCatalog(payload._id, toArray(payload)).then((response) => {
                const data = toObject(response.data);
                commit("UPDATE_CATALOG", data);
            });
        },
        deleteCatalog({ commit }, id) {
            return deleteCatalog(id).then(() => {
                commit("DELETE_CATALOG", id);
            });
        },
    },
};

export default catalog;
